import React from 'react';
import './industries.scss';

import I_ART from 'assets/home-page/Art_Image.png';
import I_AGRICULTURE from 'assets/home-page/Agriculture_Image.png';
import I_BUSINESS from 'assets/home-page/Business_Image.png';
import I_CONSTRUCTION from 'assets/home-page/Construction_Image.png';
import I_ENTERTAINMENT from 'assets/home-page/Entertainment_Image.png';
import I_FASHION from 'assets/home-page/Fashion_Image.png';
import I_FITNESS from 'assets/home-page/Gym_Image.png';
import I_TECHNOLOGY from 'assets/home-page/Tech_Image.png';
import {HashLink} from "react-router-hash-link";

export const Industries: React.FC = () => {
    return (
        <div className={"industries"}>
            <div className="industries_wrapper max">
                <div className="industries_wrapper_top">
                    <h1>What Ever you do You Have Our <span>Support.</span></h1>
                    <p>We strongly embrace entrepreneurship and creative thinking; therefore supporting businesses in all industries. All you need is an idea to innovate.</p>
                </div>
                <div className="industries_wrapper_bottom">
                    <p id={'floating_text'}>Please select a business category from the gallery below to view more information on your business industry.</p>
                    <div className="industries_wrapper_bottom_container container_art">
                        <img src={I_ART} alt=""/>
                        <div className="industries_wrapper_bottom_container_info container_art_info">
                            <div>
                                <h1>Designing Art</h1>
                                <span> <HashLink smooth
                                                 to="/business-education#business_industries">Click Me!</HashLink></span>
                            </div>
                        </div>
                    </div>
                    <div className="industries_wrapper_bottom_container container_business">
                        <img src={I_BUSINESS} alt=""/>
                        <div className="industries_wrapper_bottom_container_info container_business_info">
                            <div>
                                <h1>Business Services</h1>

                                <span> <HashLink smooth
                                                 to="/business-education#business_industries">Click Me!</HashLink></span>
                            </div>
                        </div>
                    </div>
                    <div className="industries_wrapper_bottom_container container_construction">
                        <img src={I_CONSTRUCTION} alt=""/>
                        <div className="industries_wrapper_bottom_container_info container_construction_info">
                            <div>
                                <h1>Construction</h1>
                                <span> <HashLink smooth
                                                 to="/business-education#business_industries">Click Me!</HashLink></span>
                            </div>
                        </div>
                    </div>
                    <div className="industries_wrapper_bottom_container container_entertainment">
                        <img src={I_ENTERTAINMENT} alt=""/>
                        <div className="industries_wrapper_bottom_container_info container_entertainment_info">
                            <div>
                                <h1>Entertainment & Sport </h1>
                                <span> <HashLink smooth
                                                 to="/business-education#business_industries">Click Me!</HashLink></span>
                            </div>
                        </div>
                    </div>
                    <div className="industries_wrapper_bottom_container container_fashion">
                        <img src={I_FASHION} alt=""/>
                        <div className="industries_wrapper_bottom_container_info container_fashion_info">
                            <div>
                                <h1>Fashion</h1>
                                <span> <HashLink smooth
                                                 to="/business-education#business_industries">Click Me!</HashLink></span>
                            </div>
                        </div>
                    </div>
                    <div className="industries_wrapper_bottom_container container_fitness">
                        <img src={I_FITNESS} alt=""/>
                        <div className="industries_wrapper_bottom_container_info container_fitness_info">
                            <div>
                                <h1>Fitness</h1>
                                <span> <HashLink smooth
                                                 to="/business-education#business_industries">Click Me!</HashLink></span>
                            </div>
                        </div>
                    </div>
                    <div className="industries_wrapper_bottom_container container_technology">
                        <img src={I_TECHNOLOGY} alt=""/>
                        <div className="industries_wrapper_bottom_container_info container_technology_info">
                            <div>
                                <h1>Science & Technology </h1>
                                <span> <HashLink smooth
                                                 to="/business-education#business_industries">Click Me!</HashLink></span>
                            </div>
                        </div>
                    </div>
                    <div className="industries_wrapper_bottom_container container_agriculture">
                        <img src={I_AGRICULTURE} alt=""/>
                        <div className="industries_wrapper_bottom_container_info container_agriculture_info">
                            <div>
                                <h1>Agriculture & Fishing</h1>
                                <span> <HashLink smooth
                                                 to="/business-education#business_industries">Click Me!</HashLink></span>
                            </div>
                        </div>
                    </div>

                </div>
                <svg className={'industries_poly-bottom'} height="44" fill="none" xmlns="http://www.w3.org/2000/svg"/>

            </div>
        </div>
    );
};

